import React from "react";
import { createImageFromInitials } from "../../AgentLogo";
import Avatar from "../../static/images/tia.png";

export default function TravelChatHeader({ agentName, showModal, messageCounter, botName, miniMize }) {
  return (
    <header>
      {agentName ?
        <img
          id='preview'
          src={
            createImageFromInitials(500, agentName, "blue")  //getRandomColor()
          }
          alt='profile-pic'
        />
        :
        <img src={Avatar} alt=""></img>
      }
      <div>
        <h2>Chat with {agentName ? agentName : botName || "Policybazaar"}</h2>
      </div>
      <div>
        {messageCounter > 0 ? messageCounter : null}
      </div>
      <div onClick={() => showModal()} className="closeIcon">&#x2715;</div>
      <div onClick={() => miniMize()} className="minimizeIcon">&minus;</div>
    </header>
  );
}
